import Vue from 'vue';
// import {
//   Form,
//   FormItem,
//   Row,
//   Col,
//   Button,
//   Input,
//   Select,
//   Option,
//   Table,
//   TableColumn,
//   Pagination,
//   Dialog
// } from 'element-ui';
import elementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/reset.css';
import '@/assets/styles/global.css';
import '@/assets/styles/elementUi.css';
import { registerGlobal } from '@/utils/env';
import $http from '@/page/plugins/$http';
import $dialog from '@/page/plugins/$dialog';
import App from './App.vue';
import createRouter from '@/page/router';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper /* { 全局组件的默认选项 } */)
Vue.use(elementUI);
Vue.use($http);
Vue.use($dialog);
// Vue.use(Form);
// Vue.use(FormItem);
// Vue.use(Row);
// Vue.use(Col);
// Vue.use(Button);
// Vue.use(Input);
// Vue.use(Select);
// Vue.use(Option);
// Vue.use(Table);
// Vue.use(TableColumn);
// Vue.use(Pagination);
// Vue.use(Dialog);

// 全局注册可复用组件
registerGlobal(
  require.context('./page/component/ui', false, /\.vue$/),
  inst => Vue.component(inst.name, inst)
);
// 全局注册mixin
registerGlobal(
  require.context('./page/mixins', false, /\.js$/),
  inst => Vue.mixin(inst)
);

Vue.config.productionTip = false;
new Vue({
  router: createRouter(
    require.context('./page/component/routes/', true, /\.vue$/)
  ),
  // store,
  render: h => h(App)
}).$mount('#app');
